import partialsLoader from './../partials/loader';
import bookingManager from './bookingManager';


export default {
  init() {
    // JavaScript to be fired on all pages
    partialsLoader.init();
    bookingManager.init();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    
    
    partialsLoader.finalize();
    bookingManager.finalize();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js